document.addEventListener('DOMContentLoaded', function() {
    const selectElement = document.querySelector('.custom-select');

    function updateClasses() {
        const selectedValue = selectElement.value;
        const documentItems = document.querySelectorAll('.document_item');
        documentItems.forEach(item => {
            if (item.getAttribute('data-value') === selectedValue) {
                item.classList.add('same-available');
            } else {
                item.classList.remove('same-available');
            }
        });
    }
    selectElement.addEventListener('change', updateClasses);
    updateClasses();
});
document.querySelector('.document_search input').addEventListener('input', function() {
    const query = this.value.toLowerCase();
    const listItems = document.querySelectorAll('.documents_grid .document_item');

    listItems.forEach(item => {
        const title = item.querySelector('.document_title').textContent.toLowerCase();
        const publisher = item.querySelector('.document_publisher')?.textContent.toLowerCase() || '';
        const description = item.querySelector('.document_description')?.textContent.toLowerCase() || '';
        const date = item.querySelector('.document_date')?.textContent.toLowerCase() || '';

        if (title.includes(query) || publisher.includes(query) || description.includes(query) || date.includes(query)) {
            item.classList.add('same-available');
            item.classList.remove('hide');
        } else {
            item.classList.add('hide');
            item.classList.remove('same-available');
        }
    });
});

var downloadLinks = document.querySelectorAll('.downloadLink');
downloadLinks.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();

        const fullUrl = this.getAttribute('href');
        const urlWithoutQueryString = fullUrl.split('?')[0]; // Split by '?' and take the first part
        const filename = urlWithoutQueryString.substring(urlWithoutQueryString.lastIndexOf('/') + 1);

        fetch(fullUrl)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => console.error('Error downloading file:', error));
    });
});